import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[trackFocusedOnce]',
})
export class TrackFocusedOnceDirective {
  @Output() firstFocus = new EventEmitter<void>();
  @Output() onFocus = new EventEmitter<void>();

  private hasFocused = false;

  @HostListener('focusin')
  public onFocusIn(): void {
    this.onFocus.emit();

    if (!this.hasFocused) {
      this.hasFocused = true;
      this.firstFocus.emit();
    }
  }
}
